import { Link, useSearchParams } from "react-router-dom";

export function SolicitarGracias() {
  const [params] = useSearchParams();
  const id = params.get("id");
  const uuid = params.get("uuid");
  const fromReturn = params.get("from_return") === "1";
  const wasAutoApproved = params.get("approved") === "1";
  const showReturnCta = !!uuid && !fromReturn;

  return (
    <div className="mx-auto max-w-lg">
      <div className="rounded-lg border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
          ✓
        </div>
        <h1 className="mt-4 text-xl font-semibold tracking-tight text-brand-900">
          {wasAutoApproved ? "Vuelo aprobado" : "Solicitud recibida"}
        </h1>
        {id ? (
          <p className="mt-1 font-mono text-sm text-slate-700">
            Vuelo <strong>{id}</strong>
          </p>
        ) : null}
        <p className="mt-4 text-sm text-slate-600">
          {wasAutoApproved
            ? "El vuelo quedó aprobado y los emails de confirmación se enviaron."
            : "Tu solicitud fue recibida y está pendiente de aprobación. Recibirás un email con la confirmación o con cualquier ajuste."}
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="rounded-md bg-brand-700 px-4 py-2 text-sm font-medium text-white hover:bg-brand-900"
          >
            OK
          </Link>
          <Link
            to="/solicitar"
            className="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-brand-50"
          >
            Ingresar otro vuelo
          </Link>
          {showReturnCta ? (
            <Link
              to={`/solicitar?return_of=${uuid}`}
              className="rounded-md border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-brand-50"
            >
              Solicitar vuelo de retorno
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
}
